import { useEffect, useRef, useState } from 'react'
import { useTaskboard } from '../lib/taskboardContext.js'
import useOutsideClose from '../lib/useOutsideClose.js'

export default function ProjectMenu({ project }) {
  const { renameProject, deleteProjectById, archiveProject } = useTaskboard()
  const [open, setOpen] = useState(false)
  const [name, setName] = useState(project.name)
  const [subtitle, setSubtitle] = useState(project.subtitle || '')
  const [confirmDelete, setConfirmDelete] = useState(false)
  const ref = useRef(null)
  useOutsideClose(ref, open, () => {
    setOpen(false)
    setConfirmDelete(false)
  })

  // Re-seed when switching projects.
  useEffect(() => {
    setName(project.name)
    setSubtitle(project.subtitle || '')
  }, [project.id])

  const dirty = name.trim() && (name.trim() !== project.name || subtitle.trim() !== (project.subtitle || ''))
  const save = () => {
    if (!dirty) return
    renameProject(project.id, { name: name.trim(), subtitle: subtitle.trim() })
    setOpen(false)
  }

  return (
    <div ref={ref} style={{ position: 'relative', marginTop: 6 }}>
      <button
        onClick={() => setOpen((v) => !v)}
        title="Project settings"
        style={{ background: 'none', border: '1px solid var(--color-divider-dark)', borderRadius: 'var(--radius-sm)', color: 'var(--color-muted)', cursor: 'pointer', width: 30, height: 30, display: 'flex', alignItems: 'center', justifyContent: 'center', lineHeight: 1, fontSize: 16 }}
      >
        ⋯
      </button>

      {open && (
        <div style={{ position: 'absolute', top: 36, left: 0, width: 280, background: 'var(--color-panel-dark)', border: '1px solid var(--color-divider-dark)', borderRadius: 'var(--radius-md)', boxShadow: 'var(--shadow-md)', padding: 12, zIndex: 25, animation: 'pop .12s ease' }}>
          <div className="eyebrow" style={{ marginBottom: 10 }}>
            <span className="tag-label" style={{ color: 'var(--color-gold)' }}>Project settings</span>
          </div>

          <span className="tag-label" style={{ color: 'var(--color-muted)', display: 'block', marginBottom: 6 }}>Name</span>
          <input value={name} onChange={(e) => setName(e.target.value)} onKeyDown={(e) => e.key === 'Enter' && save()} className="cn-input" style={{ fontSize: 14, padding: '8px 10px', marginBottom: 10 }} />
          <span className="tag-label" style={{ color: 'var(--color-muted)', display: 'block', marginBottom: 6 }}>Description</span>
          <input value={subtitle} onChange={(e) => setSubtitle(e.target.value)} onKeyDown={(e) => e.key === 'Enter' && save()} className="cn-input" style={{ fontSize: 13, padding: '8px 10px', marginBottom: 12 }} />

          <button onClick={save} disabled={!dirty} className="btn btn-gold" style={{ width: '100%', justifyContent: 'center', fontSize: 12, padding: '9px 14px', opacity: dirty ? 1 : 0.45, cursor: dirty ? 'pointer' : 'default' }}>
            Save changes
          </button>

          <button
            onClick={() => { setOpen(false); archiveProject(project.id, true) }}
            className="btn btn-ghost"
            style={{ width: '100%', justifyContent: 'center', fontSize: 12, padding: '9px 14px', marginTop: 8 }}
          >
            Archive project
          </button>

          <div style={{ borderTop: '1px solid var(--color-divider-dark)', marginTop: 12, paddingTop: 12 }}>
            {!confirmDelete ? (
              <button
                onClick={() => setConfirmDelete(true)}
                style={{ width: '100%', background: 'none', border: '1px solid rgba(197,107,92,.4)', color: 'var(--color-danger)', borderRadius: 'var(--radius-sm)', padding: '9px 14px', fontSize: 12, cursor: 'pointer', fontWeight: 600, letterSpacing: '.04em' }}
              >
                Delete project
              </button>
            ) : (
              <div>
                <div style={{ fontSize: 12, color: 'var(--text-body)', lineHeight: 1.5, marginBottom: 10 }}>
                  Delete <strong style={{ color: 'var(--color-white)' }}>{project.name}</strong> and all its tasks? This can’t be undone.
                </div>
                <div style={{ display: 'flex', gap: 8 }}>
                  <button onClick={() => setConfirmDelete(false)} className="btn btn-ghost" style={{ flex: 1, justifyContent: 'center', fontSize: 12, padding: '9px 12px' }}>Cancel</button>
                  <button
                    onClick={() => { setOpen(false); setConfirmDelete(false); deleteProjectById(project.id) }}
                    style={{ flex: 1, background: 'var(--color-danger)', color: 'var(--color-bg-dark)', border: 'none', borderRadius: 'var(--radius-sm)', padding: '9px 12px', fontSize: 12, fontWeight: 700, cursor: 'pointer' }}
                  >
                    Delete
                  </button>
                </div>
              </div>
            )}
          </div>
        </div>
      )}
    </div>
  )
}
